import { getGlobalProperty } from "./getGlobalProperty";
export var getWindow = function() {
    return getGlobalProperty("window");
};
export var getWindowOrThrow = function() {
    var window = getWindow();
    if (!window) {
        throw new Error("Could not find global window");
    }
    return window;
};
